// extracted by css-extract-rspack-plugin
export default {"switcher":"ptDjB","promo_list":"KKx3Y","promoList":"KKx3Y","appear":"ariNu"};